import { Component, OnInit } from '@angular/core';
import { Companies } from '../../../_shared/interfaces';
import { AlertService, ContactsStoreService, IAlertType } from '../../../_shared/services';
import {ClrDatagridModule, ClrDatagridSortOrder, ClrIconModule} from '@clr/angular';

import { environment as env } from "../../../../environments/environment";
import { RouterLink } from "@angular/router";
import { NgIf } from "@angular/common";
import { ClarityIcons, twoWayArrowsIcon } from "@cds/core/icon";
import { TranslocoDirective } from "@jsverse/transloco";

@Component({
  selector: 'app-contacts',
  standalone: true,
  imports: [
    RouterLink,
    NgIf,
    ClrIconModule,
    ClrDatagridModule,
    TranslocoDirective
  ],
  templateUrl: './contacts.component.html',
  styleUrl: './contacts.component.sass'
})
export class ContactsComponent implements OnInit {
  companies: Companies[] = [];
  descSort = ClrDatagridSortOrder.ASC;
  devMode: boolean;
  loading: boolean = false;

  constructor(
    private css: ContactsStoreService,
    private alertDispatcher: AlertService,
  ) {
    this.devMode = env.stages.dev;
    ClarityIcons.addIcons(twoWayArrowsIcon);
  }

  ngOnInit() {
    this.loading = true;
    this.loadList();
  }

  loadList() {
    this.css.getContacts().subscribe({
      next: data => {
        if (!data || !data.object || data.object.length === 0) {
          this.alertDispatcher.show({
            message: ' Keine Contacts gefunden! ',
            clrAlertType: IAlertType.WARNING
          }, 2000);
        }
        this.companies = data.object;
      },
      complete: () => {
        this.loading = false;
      },
      error: () => {
        return
      }
    });
  }
}
